
import { Vue, Component, Emit } from 'vue-property-decorator'

export interface ShowOptions {
  x: number
  y: number
  label: string
  onClick?: (e?: MouseEvent) => void
}

@Component({})
export default class GlobalContextMenu extends Vue {
  visible: boolean = false
  x: number = 0
  y: number = 0
  label: string = '项'

  handler?: (e?: MouseEvent) => void
  // margin from viewport edge
  margin: number = 8

  showAt(options: ShowOptions) {
    const { x, y } = options
    this.label = options.label || '项'
    this.handler = options.onClick
    this.visible = true
    // console.log('showAt instance', (this as any)._cmId)
    this.$nextTick(() => {
      const menu = this.$refs.menu as HTMLElement
      if (!menu) return
      const rect = menu.getBoundingClientRect()
      const vw = document.documentElement.clientWidth
      const vh = document.documentElement.clientHeight

      // Clamp horizontally
      if (x + rect.width + this.margin > vw) {
        this.x = Math.max(this.margin, vw - rect.width - this.margin)
      } else {
        this.x = Math.max(this.margin, x)
      }
      // Clamp vertically
      if (y + rect.height + this.margin > vh) {
        this.y = Math.max(this.margin, vh - rect.height - this.margin)
      } else {
        this.y = Math.max(this.margin, y)
      }
    })
  }

  @Emit('hide')
  hide() {
    this.visible = false
    this.handler = undefined
  }

  onItemClick(e: MouseEvent) {
    try {
      if (this.handler) this.handler(e)
    } finally {
      this.hide()
    }
  }

  onDocumentClick(e: Event) {
    if (!this.visible) return
    const menu = this.$refs.menu as HTMLElement | undefined
    if (menu && !menu.contains(e.target as Node)) {
      this.hide()
    }
  }

  onDocumentScroll() {
    // 隐藏菜单以避免位置错位（可按需改成跟随）
    if (this.visible) this.hide()
  }

  onKeyDown(e: KeyboardEvent) {
    if (this.visible && e.key === 'Escape') {
      this.hide()
    }
  }

  created() {
    // ;(this as any)._cmId = Math.random().toString(36).slice(2)
    // console.log('cm created', (this as any)._cmId)
  }

  mounted() {
    document.addEventListener('scroll', this.onDocumentScroll, true)
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('click', this.onDocumentClick)
  }

  destroy() {
    document.removeEventListener('scroll', this.onDocumentScroll, true)
    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('click', this.onDocumentClick)
  }
}
